import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'calendar-head',
  template: `
    <div class="text-center">
      <div class="">
        <div class="btn-group">
          <div class="btn btn-primary" (click)="setPreviousMonth()">
            Previous Month
          </div>
          <div class="btn btn-outline-secondary" (click)="setCurrentDate()">
               {{formatDate()}}
          </div>
          <div class="btn btn-primary" (click)="setNextMonth()">
            Next Month
          </div>
        </div>
      </div>
    </div>
  `
})

export class CalendarHeadComponent {
  @Input() view: string;

  @Input() viewDate: Date;

  @Input() locale = 'en';

  @Output() viewChange: EventEmitter<string> = new EventEmitter();

  @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();

  setPreviousMonth() {
    const currentDate = new Date(this.viewDate);
    currentDate.setMonth(this.viewDate.getMonth() - 1);
    this.viewDateChange.emit(currentDate);
  }

  setCurrentDate() {
    this.viewDateChange.emit(new Date());
  }

  setNextMonth() {
    const currentDate = new Date(this.viewDate);
    currentDate.setMonth(this.viewDate.getMonth() + 1);
    this.viewDateChange.emit(currentDate);
  }

  formatDate(): string {
    return this.viewDate.toLocaleString(this.locale, { month: 'long', year: 'numeric' });
  }
}
